import Logo from '../../icons/Logo/Logo';
import styles from './index.module.scss';
import { useTheme } from '../../hooks/useTheme';
import SocialLinks from '../SocialLinks';

const FooterSocial = () => {
  const { isDarkTheme } = useTheme();
  const fullYear = new Date().getFullYear();
  return (
    <div className={styles.footerSocialContent}>
      <Logo
        color={isDarkTheme === 'light' ? '#110229' : 'white'}
        top={'18%'}
        left={'20%'}
      />
      <p className={styles.socialTitle}>
        Welcome to our estate company, where dreams of finding your perfect home
        come true. With our dedicated team, personalized service, and vast
        property portfolio, we make your real estate journey seamless and
        rewarding.
      </p>
      <SocialLinks />

      <p>{`©${fullYear} All rights reserved.`}</p>
    </div>
  );
};

export default FooterSocial;
